import { useLayoutEffect, useState, useEffect, useRef } from "react";

export const useFloatingVerticalPosition = ({
  anchorRef,
  panelRef,
  align = "top", // "top" | "bottom"
  offset = 0,
}) => {
  const [top, setTop] = useState(0);
  const [resizeTick, setResizeTick] = useState(0);
  const isResizingRef = useRef(false);
  /* ------------------------------
     Observe vertical anchor + panel
  ------------------------------ */
  useEffect(() => {
    /*const observer = new ResizeObserver(() => {
      setResizeTick((v) => v + 1);
    });*/
    const observer = new ResizeObserver(() => {
      if (isResizingRef.current) return;

      isResizingRef.current = true;

      requestAnimationFrame(() => {
        setResizeTick((v) => v + 1);
        isResizingRef.current = false;
      });
    });
    if (anchorRef?.current) observer.observe(anchorRef.current);
    if (panelRef?.current) observer.observe(panelRef.current);

    return () => observer.disconnect();
  }, [anchorRef, panelRef]);

  /* ------------------------------
     Compute vertical position
  ------------------------------ */
  useLayoutEffect(() => {
    if (!anchorRef?.current || !panelRef?.current) return;

    const anchor = anchorRef.current;
    const panel = panelRef.current;

    const anchorRect = anchor.getBoundingClientRect();
    const panelHeight = panel.offsetHeight;

    const styles = getComputedStyle(anchor);
    const borderBottom = parseFloat(styles.borderBottomWidth) || 0;
    const borderTop = parseFloat(styles.borderTopWidth) || 0;

    let nextTop =
      align === "bottom"
        ? anchorRect.bottom - panelHeight - borderBottom
        : anchorRect.top + borderTop;

    nextTop += offset;

    /* ------------------------------
       Viewport clamp
    ------------------------------ */
    const padding = 8;
    const maxTop = window.innerHeight - panelHeight - padding;

    if (nextTop < padding) nextTop = padding;
    if (nextTop > maxTop) nextTop = maxTop;

    setTop(nextTop);
  }, [anchorRef, panelRef, align, offset, resizeTick]);

  return top;
};
